import localStorage from "local-storage";

const RESOURCE_TOO_LARGE_PREFIX = 'too-large-';

/**
 * Get qualified resource id, used to store and retrieve resources from the
 * cache in localStorage.
 *
 * @param {string} resourceIdHash - The raw resource identifier (hash, not numeric id)
 * @param {number | 'latest'} resourceVersionNumber - Desired version of resource
 * @return {string} Qualified resource id for cache
 */
export const getQualifiedResourceId = (
  resourceIdHash,
  resourceVersionNumber
) => {
  return `resource_${resourceIdHash}_version_${resourceVersionNumber}`;
};

/**
 * @param {string} resourceIdHash - The raw resource identifier (hash, not numeric id)
 * @param {number | 'latest'} resourceVersionNumber - Desired version of resource
 * @return {string} 'Resource too large' cache key
 */
export const getResourceTooLargeKey = (
  resourceIdHash,
  resourceVersionNumber
) => {
  return `${RESOURCE_TOO_LARGE_PREFIX}${getQualifiedResourceId(
    resourceIdHash,
    resourceVersionNumber
  )}`;
};

/**
 * Shorthnand for the below, which is needed (rather than
 * object.hasOwnProperty(property)) because of eslint rule no-prototype-builtins
 * @param {Object} object
 * @param {PropertyKey} property
 * @return {boolean}
 */
export const objectHasProperty = (object, property) => {
  return Object.prototype.hasOwnProperty.call(object, property);
};


/**
 * @param {string} qualifiedResourceId Qualified resource id for cache
 */
export const getCachedResource = (qualifiedResourceId) => localStorage.get(qualifiedResourceId)?.content;
